<template>
    <div class="xxxx">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">站内消息</p>
			</h1>
		</header>
		<div class="xiao_div">
			<div class="xiao_divx" v-for="item in standmsg">
			<p class="p1">{{item.msg_title}}</p>
			<p class="p2">{{item.msg_content}}</p>
			</div>
		</div>
		<p class="dd_indexend">已显示全部</p>
    </div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
  data() {
    return {
    	standmsg:[]
    }
  },
  mounted() {
    this.getAjax();
  },
  methods:{
  getAjax:function () {
  var openid=localStorage.getItem("openid");
   var successCallback =  (response) => {
      console.log('success')
      this.standmsg = response.data

    }
    var errorCallback =  (response) => {
        console.log('error')
    }
    this.$http.get(CURL+'/portal/All/getstandmsg?openid='+openid).then(successCallback,errorCallback);
  }
}
};

</script>
<style lang="scss" scoped>
.xxxx{
	width: 100%;
	float: left;
	background-color: #FFFFFF;
}
.xiao_divx{
	width: 100%;
	float: left;
	margin-top: 15px;
	background-color: #eee;
}
.p1{
	padding: 10px 20px 10px 20px;
}
.p2{
	padding: 0px 20px 10px 20px;
}
.xiao_div{
	margin-top: .4rem;
	width: 100%;
	float: left;
}
/**/
.dd_indexend{
  margin-top: 15px;
	width: 100%;
	float: left;
	padding-top: 15px;
	text-align: center;
	font-size: 15px;
	color: #777;
	padding-bottom: 15px;
	background-color: #eee;
}
/*head*/
header{
    position: fixed;
    height: .4rem;
    background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
    float: left;
    width: 100%;
}
.set_1{
    text-align: center;
    float: left;
    width: 80%;
    line-height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
}
.set_2{
    float: left;
    margin-left: 3%;
    margin-top: 12px;
    width: 5%;
    color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/xiaoxi.vue